//payroll redux slice
import { createSlice } from "@reduxjs/toolkit";


export const payrollSlice = createSlice({
  name: "payrollSlice",
  initialState: {
    selectedJournal: null,
    selectedChartOfAccount: null,
    singleViewData: null,
    listData: null,
    searchInput: "",
    filterData: null,
    paginationData: {
      currentPage: 1,
      totalPages: 1,
    },

 
  },
  reducers: {
    setSelectedJournal: (state, action) => {
      state.selectedJournal = action.payload;
    },
    setSelectedChartOfAccount: (state, action) => {
      state.selectedChartOfAccount = action.payload;
    },
    setSingleViewData: (state, action) => {
      state.singleViewData = action.payload;
    },
    setListData: (state, action) => {
      state.listData = action.payload;
    },
    setSearchInput: (state, action) => {
      state.searchInput = action.payload;
    },
    setFilterData: (state, action) => {
      state.filterData = action.payload;
    },
    setPaginationData: (state, action) => { 
      state.paginationData = action.payload;
    },
   
  },
});

export const {
  setSelectedJournal,
  setSelectedChartOfAccount,
  setSingleViewData,
  setSaveBtnLoading,
  setListData,
  setSearchInput,
  setFilterData,
  setPaginationData,

} = payrollSlice.actions;

export default payrollSlice.reducer;
